import { Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, FormControl, FormLabel, Input, ModalFooter, HStack, Spinner, Select } from '@chakra-ui/react'
import React from 'react'
import { ErrorMessage } from '../components/ErrorMessage';
import { useOperation } from '../components/useOperation';
import { IExpert } from '@/shared/IExpert';
import { EnableSendInvite } from '../components/EnableSendInvite';

export const ExpertDialog = (props: {
  onClose: () => void;

  expert: IExpert;
  onSave: (expert: IExpert, invite: boolean) => Promise<void>;

  title: string;
  description: string;

  saveLabel: string;
  savingLabel: string;
}) => {

  const [expert, setExpert] = React.useState<IExpert>(props.expert);
  const [invite, setSendInviteChecked] = React.useState(!props.expert.id);

  const [onSave, errorMessage, isProcessing] = useOperation(async () => {
    await props.onSave(expert, invite);
    props.onClose();
  }, [expert, invite]);

  const initialRef = React.useRef(null)

  const isDisabled = !expert?.name || !expert?.email;

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={initialRef}
      size={'xl'}
      isOpen
      onClose={props.onClose}
      preserveScrollBarGap
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{props.title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <ErrorMessage error={errorMessage} />
          <Text>{props.description}</Text>

          <FormControl key='ExpertRole' mt='4'>
            <FormLabel>Role</FormLabel>
            <Select
              isDisabled={isProcessing}
              value={expert?.role || 'reviewer'}
              onChange={e => setExpert({ ...expert, role: e.target.value as 'reviewer' | 'staff' })}
            >
              <option value='reviewer'>Reviewer</option>
              <option value='staff'>Staff</option>
            </Select>
            <Text p='1' fontSize='small' color='fg.subtle'>The role of the expert in the system</Text>
          </FormControl>

          <FormControl key='ExpertName' isRequired mt='4'>
            <FormLabel size='md'>Expert Name</FormLabel>
            <Input ref={initialRef}
              placeholder='Leo Vector'
              isDisabled={isProcessing}
              value={expert?.name}
              onChange={e => setExpert({ ...expert, name: e.target.value })}
            />
          </FormControl>

          <FormControl key='ExpertEmail' isRequired mt='4'>
            <FormLabel>Expert email address</FormLabel>
            <Input
              type='email'
              isDisabled={isProcessing}
              value={expert?.email}
              placeholder='leo.vector@urbandevlab.eu'
              onChange={e => setExpert({ ...expert, email: e.target.value })}
            />
          </FormControl>

          <EnableSendInvite
            isDisabled={isProcessing}
            sendInviteChecked={invite}
            setSendInviteChecked={setSendInviteChecked}
            description='Send an invitation to the expert to join the EIT UM Label portal.'
          />

        </ModalBody>

        <ModalFooter>
          <Button variant='solid' isDisabled={isDisabled || isProcessing} mr={4} onClick={onSave}>
            <HStack spacing={2}>{isProcessing && <Spinner />}<Text>{isProcessing ? props.savingLabel : props.saveLabel}</Text></HStack>
          </Button>
          <Button variant='outline' onClick={props.onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
